export default {"src":"/_next/static/media/scatteredClouds.adb628b4.svg","height":163,"width":163};